<template lang="pug">
.cursor_view(ref="inject")
</template>

<script>
import CursorFunctions from "./cursor-functions.js";
import CursorProperties from "./cursor-properties.js";
import { EventBus } from "@/events/global-bus.js";
export default {
    name: "custom-cursor",
    data: function () {
        return {
            renderContext: null,
            stage: null,
            cursor: null,
        };
    },
    mounted() {
        this.renderContext = CursorFunctions.createRenderContext();
        this.$refs.inject.appendChild(this.renderContext.view);
        this.cursor = CursorFunctions.createCursorGraphics(
            CursorProperties.radius,
            CursorProperties.color,
            CursorProperties.thickness
        );
        this.stage = CursorFunctions.createStage(this.cursor);

        CursorFunctions.renderLoop(
            this.renderContext,
            this.stage,
            this.cursor,
            CursorProperties.followSpeed
        );

        CursorFunctions.bindEffects(this.cursor);
        let self = this;
        EventBus.$on("rescan-cursor", function () {
            CursorFunctions.bindEffects(self.cursor);
        });
    },
};
</script>

<style lang="scss">
.cursor_view {
    position: fixed;
    left: 0;
    top: 0;
    pointer-events: none;
    width: 100vw;
    height: 100vh;
    z-index: 12000;
}
</style>